import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_product_to_existing_order: { message: "idle" },
};

export const add_product_to_existing_order_Slice = createSlice({
 name: "add_product_to_existing_order",
 initialState,
 reducers: {
  success_add_product_to_existing_order: (state, action) => {
   state.add_product_to_existing_order = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_product_to_existing_order: (state, action) => {
   state.add_product_to_existing_order = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_product_to_existing_order: (state) => {
   state.add_product_to_existing_order = { status: app_consts.IDLE };
  },
  loading_add_product_to_existing_order: (state) => {
   state.add_product_to_existing_order = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_product_to_existing_order, fail_add_product_to_existing_order, reset_add_product_to_existing_order, loading_add_product_to_existing_order } = add_product_to_existing_order_Slice.actions;

export default add_product_to_existing_order_Slice.reducer;